import { render } from "./mi.vue?vue&type=template&id=277fa5ee"
import script from "./mi.vue?vue&type=script&lang=js"
export * from "./mi.vue?vue&type=script&lang=js"
script.render = render

export default script